import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import KransensGummiMuiTheme from './KransensGummiMuiTheme';

export default (Component, props) => (
  <ThemeProvider theme={KransensGummiMuiTheme}>
    <Provider store={global.LitiumReduxStore}>
      <Component {...props} />
    </Provider>
  </ThemeProvider>
);
